<template>
	<div>
		<AppHeader title="비밀번호 찾기" is-history></AppHeader>
		<AppContent>
			<FindPasswordDetail></FindPasswordDetail>
		</AppContent>
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppContent from '@/components/common/AppContent';
import FindPasswordDetail from '@/components/findPassword/index';

export default {
	components: {
		AppHeader,
		AppContent,
		FindPasswordDetail,
	},
};
</script>
